import { bemBuilder } from "@chatfood/core-utils";

const className = "web-header";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
